import Success from '@assets/icons/success.svg';
import { Typography } from '@mui/material';

const SuccessStep = () => (
    <>
        <div className="flex flex-col gap-5">
            <img src={Success} width={113} className="mx-auto" />
            <Typography className="mx-auto" variant="h2" fontWeight={600}>
                Success
            </Typography>
            <Typography className="mx-auto" variant="h4" fontWeight={400} align="center">
                Your event was created successfully.
            </Typography>
        </div>
    </>
);

export { SuccessStep };
